import React, { useState } from "react";
import synlogo from "../../static/POET_Logo_Pen.png";
import landingimg from "../../static/landingimage.png";
import { useHistory } from "react-router-dom";
import HomeSubscription from "../HomeSubscription";

export default function SynthiumWebsite() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const history = useHistory();
  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .nav-link:hover {
          opacity: 0.8;
        }
        
        .login-button:hover {
          background: #1976D2;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
        }
        
        .try-free-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(33, 150, 243, 0.4);
        }
        
        .feature-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        }
        
        .chart-bar {
          animation: growBar 0.8s ease-out forwards;
        }
        
        @keyframes growBar {
          from { height: 0; }
        }
        
        @media (max-width: 768px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-button {
            display: flex !important;
          }
          .hero-content {
            grid-template-columns: 1fr !important;
            gap: 2rem !important;
          }
          .hero-title {
            font-size: 2rem !important;
          }
          .hero-image {
            min-height: 300px !important;
          }
          .person {
            display: none !important;
          }
          .mockup-card {
            max-width: 100% !important;
          }
          .section-title {
            font-size: 2rem !important;
          }
          .features-grid {
            grid-template-columns: 1fr !important;
          }
          .detailed-features-grid {
            grid-template-columns: 1fr !important;
          }
          .footer-row {
            grid-template-columns: 1fr !important;
          }
          .footer-col2, .footer-col3 {
            padding-left: 0 !important;
          }
          .footer-divider {
            display: none !important;
          }
          .footer-links {
            flex-direction: column !important;
            gap: 2rem !important;
          }
        }
        
        @media (max-width: 480px) {
          .hero-title {
            font-size: 1.5rem !important;
          }
          .logo-title {
            font-size: 25px !important;
          }
          .logo-icon {
            width: 40px !important;
            height: 40px !important;
            font-size: 20px !important;
          }
        }
      `}</style>

      {/* Header */}
      <header style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.logo}>
            <img src={synlogo} width={"80px"} />
            <div>
              <div style={styles.logoTitle} className="logo-title">
                SYNTHIUM
              </div>
              <div style={styles.logoSubtitle}>Creative Suite</div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav style={styles.desktopNav} className="desktop-nav">
            <a
              href="#about"
              style={styles.navLink}
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("about")
                  .scrollIntoView({ behavior: "smooth" });
              }}
            >
              About
            </a>
            <a
              href="#pricing"
              style={styles.navLink}
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("pricing")
                  .scrollIntoView({ behavior: "smooth" });
              }}
            >
              Pricing
            </a>
            <a
              href="#features"
              style={styles.navLink}
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("features")
                  .scrollIntoView({ behavior: "smooth" });
              }}
            >
              Features
            </a>
            <button
              style={styles.loginButton}
              onClick={() => history.push("/login")}
              className="login-button"
            >
              Login
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            style={styles.mobileMenuButton}
            className="mobile-menu-button"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            ) : (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav style={styles.mobileNav}>
            <a
              href="#about"
              style={styles.mobileNavLink}
              onClick={(e) => e.preventDefault()}
            >
              About
            </a>
            <a
              href="#pricing"
              style={styles.mobileNavLink}
              onClick={(e) => e.preventDefault()}
            >
              Pricing
            </a>
            <a
              href="#blog"
              style={styles.mobileNavLink}
              onClick={(e) => e.preventDefault()}
            >
              Blog
            </a>
            <a
              href="#features"
              style={styles.mobileNavLink}
              onClick={(e) => e.preventDefault()}
            >
              Features
            </a>
            <button style={styles.mobileLoginButton}>Login</button>
          </nav>
        )}
      </header>

      {/* Hero Section */}
      <section style={styles.hero}>
        <div style={styles.heroContent} className="hero-content">
          <div style={styles.heroText}>
            <h1 style={styles.heroTitle} className="hero-title">
              Welcome to
              <br />
              Synthium
              <br />
              Creative Suite
            </h1>
            <p style={styles.heroDescription}>
              The Synthium Creative Suite (SCS) is an industry-leading
              AI-powered document editing and collaboration ecosystem designed
              for businesses, educators, students, and researchers. It bridges
              the gap between productivity and intelligence — providing a
              unified, cloud-native workspace for writing, editing, annotating,
              and co-creating content with real-time collaboration and
              contextual AI assistance.
              <br /> At its core, Synthium Creative Suite transforms traditional
              document workflows into adaptive, intelligent experiences,
              integrating seamlessly with other Synthium Suites — especially
              Business, Enterprise, and Legal — to connect creativity with
              operations, compliance, and strategic insight.
            </p>
            <button
              style={styles.tryFreeButton}
              onClick={() => history.push("/login")}
              className="try-free-button"
            >
              Try Free
            </button>
          </div>
          <div style={styles.heroImage} className="hero-image">
            <img src={landingimg} width={"800px"} />
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" style={styles.aboutSection}>
        <h2 style={styles.sectionTitle} className="section-title">
          About Synthium Creative Suite
        </h2>
        <div style={styles.featuresGrid} className="features-grid">
          <div style={styles.featureCard} className="feature-card">
            <div style={{ ...styles.featureIcon, background: "#2196F3" }}>
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
              >
                <path d="M12 19l7-7 3 3-7 7-3-3z"></path>
                <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path>
                <path d="M2 2l7.586 7.586"></path>
              </svg>
            </div>
            <h3 style={styles.featureTitle}>Easy Write</h3>
            <p style={styles.featureDescription}>
              Synthium Suite simplifies the way teams work by providing smart,
              guided workflows that remove complexity from daily operations.
              AI-powered insights ensure your tasks, documents, and
              communications stay organized and error-free. Instead of fixing
              mistakes later, Synthium predicts, prevents, and optimizes your
              work in real time, helping your team stay aligned, productive, and
              focused — without the headaches.
            </p>
          </div>

          <div style={styles.featureCard} className="feature-card">
            <div style={{ ...styles.featureIcon, background: "#2196F3" }}>
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <h3 style={styles.featureTitle}>24 / 7 Support</h3>
            <p style={styles.featureDescription}>
              Your team’s success should never pause. Synthium Suite provides
              24/7 support through AI-driven guidance, intelligent help modules,
              real-time suggestions, and instant documentation. From onboarding
              to advanced workflows, your team gets seamless support anytime —
              through our help desk, guides, AI assistants, and live support
              options — ensuring uninterrupted productivity day or night.
            </p>
          </div>

          <div style={styles.featureCard} className="feature-card">
            <div style={{ ...styles.featureIcon, background: "#2196F3" }}>
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
              >
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              </svg>
            </div>
            <h3 style={styles.featureTitle}>Data Privacy</h3>
            <p style={styles.featureDescription}>
              Security is built into every layer of Synthium Suite. We protect
              your operational and client data with enterprise-grade encryption,
              strict access controls, and compliance with global standards like
              GDPR, SOC 2, and HIPAA. Your business remains safe, transparent,
              and fully protected — giving your team and customers the
              confidence to collaborate without compromise.
            </p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={styles.featuresSection} id="features">
        <h2 style={styles.featuresSectionTitle}>Features</h2>
        <div
          style={styles.detailedFeaturesGrid}
          className="detailed-features-grid"
        >
          <div style={styles.detailedFeature}>
            <div style={styles.detailedFeatureIcon}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#2196F3"
                strokeWidth="2"
              >
                <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
                <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
                <line x1="6" y1="6" x2="6.01" y2="6"></line>
                <line x1="6" y1="18" x2="6.01" y2="18"></line>
              </svg>
            </div>
            <div>
              <h3 style={styles.detailedFeatureTitle}>AI-Powered Products</h3>
              <p style={styles.detailedFeatureDescription}>
                Synthium Suite uses advanced AI to enhance every stage of
                operational workflows — from client management to documents,
                tasks, pipelines, and approvals. Our intelligence engine
                analyzes activity patterns, identifies risks, recommends next
                actions, and ensures teams stay aligned and proactive. With
                real-time insights, automated suggestions, predictive scoring,
                and assisted decision-making, Synthium helps teams work faster,
                smarter, and with greater clarity.
              </p>
            </div>
          </div>

          <div style={styles.detailedFeature}>
            <div style={styles.detailedFeatureIcon}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#2196F3"
                strokeWidth="2"
              >
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
            </div>
            <div>
              <h3 style={styles.detailedFeatureTitle}>Digital Writing</h3>
              <p style={styles.detailedFeatureDescription}>
                Synthium Suite unifies all your core business workflows into one
                integrated digital platform — eliminating fragmented tools and
                manual processes. From sales journeys to client documents,
                invoicing, communication timelines, and operational checkpoints,
                every workflow stays connected, consistent, and visible. Digital
                workflows ensure your team can execute work seamlessly across
                modules without switching apps or losing information.
              </p>
            </div>
          </div>

          <div style={styles.detailedFeature}>
            <div style={styles.detailedFeatureIcon}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#2196F3"
                strokeWidth="2"
              >
                <circle cx="18" cy="5" r="3"></circle>
                <circle cx="6" cy="12" r="3"></circle>
                <circle cx="18" cy="19" r="3"></circle>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
              </svg>
            </div>
            <div>
              <h3 style={styles.detailedFeatureTitle}>Sharing with Team</h3>
              <p style={styles.detailedFeatureDescription}>
                Built for modern, distributed teams, Synthium Suite enables
                seamless collaboration across departments and roles. Teams can
                share documents, coordinate tasks, track activity timelines,
                manage approvals, and communicate within a unified workspace.
                Whether your organization is hybrid, remote, or global, Synthium
                keeps everyone aligned, informed, and working together without
                friction.
              </p>
            </div>
          </div>

          <div style={styles.detailedFeature}>
            <div style={styles.detailedFeatureIcon}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#2196F3"
                strokeWidth="2"
              >
                <path d="M12 20h9"></path>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
              </svg>
            </div>
            <div>
              <h3 style={styles.detailedFeatureTitle}>Flexible Writing</h3>
              <p style={styles.detailedFeatureDescription}>
                Synthium Suite adapts to your team’s preferred way of working —
                structured or flexible. Every module works independently or as
                part of a larger end-to-end workflow, giving teams the freedom
                to manage their tasks, documents, client interactions, and
                approvals the way they prefer. With customizable pipelines,
                smart automations, and modular configuration, Synthium scales
                effortlessly with your processes.
              </p>
            </div>
          </div>

          <div style={styles.detailedFeature}>
            <div style={styles.detailedFeatureIcon}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#2196F3"
                strokeWidth="2"
              >
                <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
                <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
                <line x1="6" y1="6" x2="6.01" y2="6"></line>
                <line x1="6" y1="18" x2="6.01" y2="18"></line>
              </svg>
            </div>
            <div>
              <h3 style={styles.detailedFeatureTitle}>
                Unified Data Intelligence
              </h3>
              <p style={styles.detailedFeatureDescription}>
                Synthium Suite brings all your business data together — deals,
                documents, clients, tasks, timelines, invoices, and compliance
                logs — into one unified intelligence layer. This gives teams a
                single source of truth with real-time visibility, cross-module
                analytics, and actionable insights. No more switching tools or
                juggling spreadsheets — all critical information becomes
                instantly accessible and always up-to-date.
              </p>
            </div>
          </div>

          <div style={styles.detailedFeature}>
            <div style={styles.detailedFeatureIcon}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#2196F3"
                strokeWidth="2"
              >
                <path d="M12 20h9"></path>
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
              </svg>
            </div>
            <div>
              <h3 style={styles.detailedFeatureTitle}>Seamless Integrations</h3>
              <p style={styles.detailedFeatureDescription}>
                Synthium Suite connects effortlessly with the rest of your
                ecosystem, including CRM platforms, billing tools, email
                systems, cloud storage, security providers, and enterprise
                applications. Bi-directional sync ensures your data stays
                consistent everywhere, reducing manual work, preventing errors,
                and keeping operations running smoothly. Integrations make
                Synthium Suite a natural extension of your entire business
                workflow.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={styles.ctaSection} id="pricing">
        {/* <h2 style={styles.ctaTitle}>Select your plan</h2> */}
        {/* <h2 className="text-center">Pricing</h2> */}
        <HomeSubscription hide={true} />
      </section>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerContent}>
          <div style={styles.footerRow}>
            {/* Column 1 - Company Info */}
            <div style={styles.footerCol1}>
              <div style={styles.footerLogo}>
                <img src={synlogo} width={"80px"} />
                <div>
                  <div style={styles.footerLogoTitle}>SYNTHIUM</div>
                  <div style={styles.footerLogoSubtitle}>Creative Suite</div>
                </div>
              </div>

              <div style={styles.footerInfo}>
                <p style={styles.footerInfoItem}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#666"
                    strokeWidth="2"
                    style={styles.footerIcon}
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  <span style={styles.footerText}>
                    22738, Maple Road Suite 120, Lexington Park, Maryland, 20634
                  </span>
                </p>

                <p style={styles.footerInfoItem}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#666"
                    strokeWidth="2"
                    style={styles.footerIcon}
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  <span style={styles.footerText}>301-997-5695</span>
                </p>

                <p style={styles.footerInfoItem}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#666"
                    strokeWidth="2"
                    style={styles.footerIcon}
                  >
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                    <polyline points="22,6 12,13 2,6"></polyline>
                  </svg>
                  <span style={styles.footerText}>
                    admin@synthiumcreative.com
                  </span>
                </p>
              </div>
            </div>

            {/* Column 2 - Links */}
            <div style={styles.footerCol2} className="footer-col2">
              <div
                style={styles.footerDivider}
                className="footer-divider"
              ></div>
              <div style={styles.footerLinks} className="footer-links">
                <div style={styles.footerLinkGroup}>
                  <h4 style={styles.footerLinkTitle}>Company</h4>
                  <a
                    href="#about"
                    style={styles.footerLink}
                    className="footer-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    About Us
                  </a>
                  <a
                    href="#privacy"
                    style={styles.footerLink}
                    className="footer-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    Privacy Policy
                  </a>
                </div>

                <div style={styles.footerLinkGroup}>
                  <h4 style={styles.footerLinkTitle}>Legal</h4>
                  <a
                    href="#faq"
                    style={styles.footerLink}
                    className="footer-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    FAQ
                  </a>
                  <a
                    href="#terms"
                    style={styles.footerLink}
                    className="footer-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    Terms of Service
                  </a>
                </div>

                <div style={styles.footerLinkGroup}>
                  <h4 style={styles.footerLinkTitle}>Features</h4>
                  <a
                    href="#grammar"
                    style={styles.footerLink}
                    className="footer-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    Grammar Check
                  </a>
                  <a
                    href="#citation"
                    style={styles.footerLink}
                    className="footer-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    Citation Generator
                  </a>
                  <a
                    href="#paraphrase"
                    style={styles.footerLink}
                    className="footer-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    Paraphraser
                  </a>
                  <a
                    href="#plagiarism"
                    style={styles.footerLink}
                    className="footer-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    Plagiarism
                  </a>
                </div>
              </div>
            </div>

            {/* Column 3 - Social Media */}
            <div style={styles.footerCol3} className="footer-col3">
              <div
                style={styles.footerDivider}
                className="footer-divider"
              ></div>
              <div style={styles.socialSection}>
                <button
                  style={styles.scrollUpButton}
                  className="scroll-up-button"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                  >
                    <line x1="12" y1="19" x2="12" y2="5"></line>
                    <polyline points="5 12 12 5 19 12"></polyline>
                  </svg>
                </button>
                <div style={styles.socialIcons}>
                  <a
                    href="https://facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.socialIcon}
                    className="social-icon"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#666">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                  </a>
                  <a
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.socialIcon}
                    className="social-icon"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#666">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                    </svg>
                  </a>
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.socialIcon}
                    className="social-icon"
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="#666">
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Bar */}
        <div style={styles.copyrightBar}>
          <p style={styles.copyrightText}>
            Copyright © Synthium Creative Suite Inc. All Rights Reserved
          </p>
        </div>
      </footer>
    </div>
  );
}

const styles = {
  container: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: "#333",
    minHeight: "100vh",
  },
  header: {
    background: "#003366",
    padding: "1rem 2rem",
    position: "sticky",
    top: 0,
    zIndex: 1000,
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  headerContent: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    // gap: "1rem",
    color: "white",
  },
  logoIcon: {
    width: "50px",
    height: "50px",
    background: "linear-gradient(135deg, #2196F3, #1976D2)",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    fontWeight: "bold",
  },
  logoTitle: {
    fontSize: "30px",
    fontWeight: "bold",
    letterSpacing: "2px",
  },
  logoSubtitle: {
    fontSize: "15px",
    letterSpacing: "2px",
    paddingTop: "2px",
  },
  desktopNav: {
    display: "flex",
    gap: "2rem",
    alignItems: "center",
  },
  navLink: {
    color: "white",
    textDecoration: "none",
    fontSize: "16px",
    transition: "opacity 0.3s",
  },
  loginButton: {
    background: "#2196F3",
    color: "white",
    border: "none",
    padding: "0.75rem 2rem",
    borderRadius: "25px",
    fontSize: "16px",
    cursor: "pointer",
    transition: "all 0.3s",
  },
  mobileMenuButton: {
    display: "none",
    background: "transparent",
    border: "none",
    color: "white",
    cursor: "pointer",
    padding: "0.5rem",
    alignItems: "center",
    justifyContent: "center",
  },
  mobileNav: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    marginTop: "1rem",
    paddingTop: "1rem",
    borderTop: "1px solid rgba(255,255,255,0.2)",
  },
  mobileNavLink: {
    color: "white",
    textDecoration: "none",
    fontSize: "16px",
    padding: "0.5rem 0",
  },
  mobileLoginButton: {
    background: "#2196F3",
    color: "white",
    border: "none",
    padding: "0.75rem",
    borderRadius: "25px",
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "0.5rem",
  },
  hero: {
    background: "#003366",
    padding: "2rem 2rem",
    color: "white",
  },
  heroContent: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "3rem",
    alignItems: "center",
  },
  heroText: {
    maxWidth: "500px",
    width: "500px",
  },
  heroTitle: {
    fontSize: "3rem",
    fontWeight: "bold",
    lineHeight: "1.2",
    marginBottom: "1.5rem",
  },
  heroDescription: {
    fontSize: "1rem",
    lineHeight: "1.6",
    marginBottom: "2rem",
    opacity: 0.9,
  },
  tryFreeButton: {
    background: "#2196F3",
    color: "white",
    border: "none",
    padding: "1rem 3rem",
    borderRadius: "30px",
    fontSize: "18px",
    cursor: "pointer",
    fontWeight: "600",
    transition: "all 0.3s",
  },
  heroImage: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
  },
  mockupCard: {
    background: "white",
    borderRadius: "12px",
    padding: "2rem",
    width: "100%",
    maxWidth: "400px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
    position: "relative",
    zIndex: 2,
  },
  mockupHeader: {
    marginBottom: "2rem",
  },
  mockupLine1: {
    height: "12px",
    background: "#2196F3",
    borderRadius: "6px",
    width: "60%",
    marginBottom: "0.5rem",
  },
  mockupLine2: {
    height: "8px",
    background: "#E3F2FD",
    borderRadius: "4px",
    width: "80%",
  },
  chartContainer: {
    display: "flex",
    gap: "1rem",
    alignItems: "flex-end",
    height: "150px",
  },
  chartBar: {
    flex: 1,
    background: "#2196F3",
    borderRadius: "4px 4px 0 0",
  },
  person1: {
    position: "absolute",
    left: "-50px",
    bottom: "50px",
    width: "120px",
    height: "150px",
    background: "#1976D2",
    borderRadius: "60px 60px 0 0",
    zIndex: 1,
  },
  person2: {
    position: "absolute",
    right: "-30px",
    bottom: "30px",
    width: "100px",
    height: "140px",
    background: "#1976D2",
    borderRadius: "50px 50px 0 0",
    zIndex: 1,
  },
  aboutSection: {
    padding: "5rem 2rem",
    background: "#f5f5f5",
  },
  sectionTitle: {
    fontSize: "2.5rem",
    textAlign: "center",
    marginBottom: "4rem",
    color: "#003366",
    fontWeight: "bold",
  },
  featuresGrid: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "3rem",
  },
  featureCard: {
    textAlign: "center",
    padding: "2rem",
    background: "white",
    borderRadius: "12px",
    transition: "all 0.3s",
  },
  featureIcon: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 1.5rem",
  },
  featureTitle: {
    fontSize: "1.5rem",
    marginBottom: "1rem",
    color: "#003366",
    fontWeight: "bold",
  },
  featureDescription: {
    fontSize: "0.95rem",
    lineHeight: "1.6",
    color: "#666",
  },
  featuresSection: {
    background: "#003366",
    padding: "5rem 2rem",
    color: "white",
  },
  featuresSectionTitle: {
    fontSize: "2.5rem",
    textAlign: "center",
    marginBottom: "4rem",
    fontWeight: "bold",
  },
  detailedFeaturesGrid: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "3rem",
  },
  detailedFeature: {
    display: "flex",
    gap: "1.5rem",
  },
  detailedFeatureIcon: {
    width: "60px",
    height: "60px",
    background: "white",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  detailedFeatureTitle: {
    fontSize: "1.3rem",
    marginBottom: "0.75rem",
    fontWeight: "bold",
  },
  detailedFeatureDescription: {
    fontSize: "0.95rem",
    lineHeight: "1.6",
    opacity: 0.9,
  },
  ctaSection: {
    padding: "5rem 2rem",
    background: "#f5f5f5",
  },
  ctaTitle: {
    fontSize: "2.5rem",
    textAlign: "center",
    color: "#003366",
    fontWeight: "bold",
  },
  footer: {
    backgroundColor: "#003366",
    color: "#fff",
  },
  footerContent: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "3rem 2rem",
  },
  footerRow: {
    display: "grid",
    gridTemplateColumns: "2fr 2fr 1fr",
    gap: "3rem",
  },
  footerCol1: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
  footerLogo: {
    display: "flex",
    alignItems: "center",
    // gap: "1rem",
    color: "white",
  },
  footerLogoIcon: {
    width: "45px",
    height: "45px",
    background: "linear-gradient(135deg, #2196F3, #1976D2)",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "22px",
    fontWeight: "bold",
  },
  footerLogoTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    letterSpacing: "2px",
  },
  footerLogoSubtitle: {
    fontSize: "11px",
    letterSpacing: "1px",
    opacity: 0.8,
  },
  footerInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  footerInfoItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "0.75rem",
    margin: 0,
  },
  footerIcon: {
    flexShrink: 0,
    marginTop: "2px",
  },
  footerText: {
    color: "rgba(255, 255, 255, 0.8)",
    fontSize: "13px",
    lineHeight: "1.5",
  },
  footerCol2: {
    display: "flex",
    gap: "2rem",
    position: "relative",
  },
  footerDivider: {
    width: "1px",
    background: "rgba(255, 255, 255, 0.2)",
  },
  footerLinks: {
    display: "flex",
    gap: "3rem",
    flex: 1,
  },
  footerLinkGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  footerLinkTitle: {
    fontSize: "17px",
    color: "#ffffff",
    fontWeight: "600",
    marginBottom: "0.5rem",
  },
  footerLink: {
    fontFamily: "Roboto",
    fontSize: "12px",
    lineHeight: "2.5",
    color: "rgba(255, 255, 255, 0.7)",
    textDecoration: "none",
    transition: "color 0.3s",
    cursor: "pointer",
    width:'max-content'
  },
  footerCol3: {
    display: "flex",
    gap: "2rem",
    position: "relative",
  },
  socialSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "2rem",
    flex: 1,
    paddingTop: "2rem",
  },
  scrollUpButton: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    background: "#2196F3",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.3s",
  },
  socialIcons: {
    display: "flex",
    gap: "1rem",
    justifyContent: "center",
  },
  socialIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    background: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.3s",
    cursor: "pointer",
  },
  copyrightBar: {
    background: "#f5f5f5",
    padding: "1rem 2rem",
    textAlign: "center",
    borderTop: "1px solid #e0e0e0",
  },
  copyrightText: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "300",
    color: "#666",
    margin: 0,
  },
};
